// Rellena la fecha de entrega del bloque de envío. Los helpers viven en
// lanzo-fechas.js, compartido con el bloque de fecha de entrega.
class LanzoEnvio extends HTMLElement {
  connectedCallback() {
    const out = this.querySelector('[data-lanzo-range]');
    if (!out) return;

    const locale = this.dataset.locale || 'es-CO';
    const skipWeekends = this.dataset.skipWeekends === 'true';
    const skipHolidays = this.dataset.skipHolidays === 'true';
    const min = parseInt(this.dataset.daysMin, 10) || 0;
    const max = Math.max(min, parseInt(this.dataset.daysMax, 10) || 0);
    const hoy = new Date();

    out.textContent = lanzoRange(
      lanzoAddDays(hoy, min, skipWeekends, skipHolidays),
      lanzoAddDays(hoy, max, skipWeekends, skipHolidays),
      locale
    );
  }
}

customElements.define('lanzo-envio', LanzoEnvio);
